import { createSelector } from 'reselect';

import { FLAG_KEYS } from 'lib/constants';
import { getLaunchDarklyFlags } from './getLaunchDarklyFlags';

// Sign operators in by typing their ERP employee ID instead of picking a name.
const getPinPadSignInEnabled = createSelector(
  [getLaunchDarklyFlags],
  (flags) => {
    return flags?.[FLAG_KEYS.PIN_PAD_SIGN_IN_ENABLED] === true;
  }
);

export { getPinPadSignInEnabled };
